












































































































































import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    Component,
    Vue,
    Prop,
    Watch
} from "vue-property-decorator";
import {
    pageDataType,
    componentDataType,
    SocialItem
} from "../types";
import {
    API_URL
} from "../global";
import axios from "axios";
import {
    ValidationObserver,
    ValidationProvider
} from "vee-validate";
// import vSelect from 'vue-select';
// Vue.component('v-select', vSelect);
import {
    FETCH_SOCIAL
} from "../store/actions.names";
const DEFAULT_CONTACT_FORM = {
    name: "",
    email: "",
    phone: "",
    message: "",
    topic: null,

};
@Component({
    name: "ContactCards",
    components: {
        ValidationObserver,
        ValidationProvider
    }
})
export default class ContactCards extends Vue {
    @Getter("socialIcon") public socialIcon!: SocialItem[];
    @Prop() public compData!: string | null;
    //public HOST: string = HOST;
    @Action(FETCH_SOCIAL) public[FETCH_SOCIAL]: any;
    public contactform: any = JSON.parse(JSON.stringify(DEFAULT_CONTACT_FORM));
    submitted: boolean = false;
    submitSuccess: boolean = false;
    public data() {
        return {
            topic: '',
            items: {
                1: {
                    id: 1,
                    val: 'Bussiness'
                },
                2: {
                    id: 2,
                    val: 'Personal'
                },
                // 3: {
                //     id: 3,
                //     val: 'item3'
                // },
            }
        }
    }
    public conform() {
        const setActive = (el: any, active: any) => {
            const formField = el.parentNode.parentNode;
            if (active) {
                formField.classList.add("form-field--is-active");
            } else {
                formField.classList.remove("form-field--is-active");
                el.value === "" ?
                    formField.classList.remove("form-field--is-filled") :
                    formField.classList.add("form-field--is-filled");
            }
        };

        [].forEach.call(
            document.querySelectorAll(".form-field__input, .form-field__textarea"),
            (el: any) => {
                el.onblur = () => {
                    setActive(el, false);
                };
                el.onfocus = () => {
                    setActive(el, true);
                };
            }
        );
    }
    resetForm() {
        this.contactform = JSON.parse(JSON.stringify(DEFAULT_CONTACT_FORM));
    }
    submitForm() {
        //   this.$validator.validate().then(valid => {
        //             if (valid) {
        axios
            .post(`${API_URL}/contact-form/`, this.contactform)
            .then((resp: any) => {
                this.submitted = true;
                this.submitSuccess = true;
            })
            .catch((err: any) => {
                this.submitted = true;
            });
        //     }
        // });
    }
    public mounted() {
        this.conform();
        this[FETCH_SOCIAL]();
    }

}
